import React from "react";

const RadioGroup = ({
  label,
  name,
  value,
  selectedValue,
  onChange,
  options,
  required = false,
  readOnly = false,
}) => {
  // Support both 'value' and 'selectedValue' props for backward compatibility
  const currentValue = selectedValue !== undefined ? selectedValue : value;
  return (
    <div className="space-y-4">
      {label && (
        <label className="text-sm font-medium text-foreground block">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      <div className="space-y-3">
        {(options || []).map((option) => (
          <div
            key={option.value}
            className={`flex items-start space-x-3 p-3 rounded-sm border transition-colors ${
              readOnly
                ? "border-gray-200 bg-gray-50"
                : currentValue === option.value
                ? "border-primary bg-primary/5"
                : "border-gray-200 bg-background hover:border-gray-300 hover:bg-accent/30"
            }`}
          >
            <input
              type="radio"
              id={`${name}-${option.value}`}
              name={name}
              value={option.value}
              checked={currentValue === option.value}
              onChange={onChange}
              required={required}
              disabled={readOnly}
              className={`h-4 w-4 rounded-full border transition-colors focus:ring-1 focus:ring-ring focus:ring-offset-0 ${
                readOnly
                  ? "border-gray-200 cursor-not-allowed"
                  : "border-gray-200 text-primary hover:border-gray-300 focus:border-primary"
              }`}
            />
            <label
              htmlFor={`${name}-${option.value}`}
              className={`text-sm leading-relaxed ${
                readOnly ? "text-muted-foreground cursor-not-allowed" : "text-foreground cursor-pointer"
              }`}
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RadioGroup;
